import './header.less'

import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';
import {getUser} from '../../helpers/session';
import {Badge, Button} from 'antd';

const Action = (props) => <NavLink to={props.to}>{props.children}</NavLink>;

class Header extends Component {

  render() {
    const user = getUser();
    const isAdmin = user && user.user && user.user.type === 'admin';
    const isUser = user && user.user && user.user.type === 'user';

    return (
      <div className="header">
        <div className="left">
          <div className="logo">
            <img src={'/logo.png'} />
          </div>
        </div>
        <div className="right">
          {!isUser && <Action to={'/our-clients'}>Наши клиенты</Action>}
          {isUser && <Action to={'/user/cars'}>Мои машины</Action>}
          {isAdmin && <Action to={'/req-clients'}>Потенциальные клиенты</Action>}
          {isAdmin && <Action to={'/arc-clients'}>Архив</Action>}
          {isAdmin && <Action to={'/stats'}>Статистика</Action>}


          {isAdmin && <Badge count={this.props.crmCountUnread} overflowCount={999}><Action to={'/crm'}>CRM</Action></Badge>}

          {isAdmin && <Action to={'/admin'}>Настройки</Action>}
        </div>
        <div className="title">{this.props.title || ''}</div>
        <div className="tools">{this.props.tools || ''}</div>
        <div className="user">
          <Button ghost type={'primary'} onClick={this.props.onLogout}>Выход</Button>
        </div>
      </div>
    );
  }

}

export default Header



// WEBPACK FOOTER //
// ./src/components/common/header.js